module.exports = __webpack_public_path__ + "static/Plein Air Instruction-1b26fe637ed48d60c00c35505a80b44a.pdf";